import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const usePlanVisionStore = defineStore('planVision', () => {
  const planVision = ref(null);

  const setPlanVision = data => {
    planVision.value = data;
  };

  const storeHasPlanVision = computed(() => !!planVision.value);

  const clearPlanVision = () => {
    planVision.value = null;
  };

  return {
    planVision,
    clearPlanVision,
    setPlanVision,
    storeHasPlanVision,
  };
});
